module.exports = __webpack_public_path__ + "static/media/sapporobestlap.5df68874.svg";